/**
 * The six statuses the store holds, with the label and colour family each carries. The status bar
 * draws a dot and the usage table draws a pill, so they share the meaning and keep their own
 * class maps.
 */

export type SubscriptionStatusTone = 'emerald' | 'blue' | 'amber' | 'red';

export const SUBSCRIPTION_STATUS_LABELS: Record<string, string> = {
  active: 'Active',
  trialing: 'Trial',
  suspended: 'Suspended',
  past_due: 'Past due',
  cancelled: 'Cancelled',
  expired: 'Expired',
};

export const SUBSCRIPTION_STATUS_TONES: Record<string, SubscriptionStatusTone> = {
  active: 'emerald',
  trialing: 'blue',
  suspended: 'amber',
  past_due: 'amber',
  cancelled: 'red',
  expired: 'red',
};
